/** Contenedor de filtros (toolbar). */
export default function FilterBar({ children, label = 'Filtros' }) {
  return (
    <div className="analytics-toolbar shared-filter-bar" role="toolbar" aria-label={label}>
      {children}
    </div>
  );
}
